import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-6 col-lg-8" }, "Neem contact op met support@digital-pharma.be voor het verder configureren van deze instellingen.", -1)
const _hoisted_3 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_4 = { class: "card mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "card-title mb-0" }, "Webhook URL")
], -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mas" }, "content_copy", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: "Sendcloud",
        mb: 4,
        "back-route": {name: 'pharma-shipping'}
      }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("input", {
                  ref: "webhookUrl",
                  id: "webhook_url",
                  class: "form-control",
                  type: "text",
                  value: this.webhookUrl,
                  "aria-label": "readonly input",
                  readonly: ""
                }, null, 8, _hoisted_8),
                _createElementVNode("button", {
                  class: "btn btn-outline-primary",
                  title: _ctx.$t('copyToClipboard'),
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyToClipboard(this.$refs.webhookUrl.value)), ["prevent"]))
                }, _hoisted_11, 8, _hoisted_9)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}